// extracted by css-extract-rspack-plugin
export default {"tokens":"hljs-tokens-module__tokens__YUsSS"};